import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CalcAProofUploadForm } from '../parts/CalcAProofUploadForm';
import { CalcAProofDtMode } from '../parts/CalcAProofDtMode';
import { CalcAProofDtInput } from '../parts/CalcAProofDtInput';
import { CalcAProofDtOutput } from '../parts/CalcAProofDtOutput';
import { CalcAProofDtResult } from '../parts/CalcAProofDtResult';
import './CalcAProof.css';
import { useUserContext } from '../../contexts/UserContext';
import { CalcAProofResult, AProofElectrolyzer, CalcAProofResultDefaultData } from '../parts/CalcAProofData';

export const CalcAProof: React.FC = () => {
    const userContext = useUserContext();
    const [calcResult, setCalcResult] = useState<CalcAProofResult>({});
    const getAProofUnit = () => {
        const defaultData: AProofElectrolyzer[] =
            CalcAProofResultDefaultData.electroyzerList ? CalcAProofResultDefaultData.electroyzerList : [];
        if (calcResult?.electroyzerList === undefined) {
            console.log('getAProofUnit: defaultData.');
            return defaultData;
        }
        console.log('getAProofUnit: is not empty. length=' + calcResult?.electroyzerList.length);
        return calcResult?.electroyzerList;
    }

    if (!userContext.isLoggedIn) {
        userContext.logout();
        window.location.href = '/';
    }

    userContext.availableFunction(userContext.idToken, {
        onFuncSuccess: function (funcList) {
            let availableflg;
            // availableflg = funcList.some((funcList) => funcList.functionId == target);
            availableflg = userContext.isAvailableFunc('calcap', funcList);
            if (!availableflg) {
                console.log('isAvailableFunc: FAILURE availableflg = ' + availableflg);
                userContext.logout();
                window.location.href = '/';
            } else {
                console.log('isAvailableFunc: SUCCESS availableflg = ' + availableflg);
            }
        },
        onFuncFailure: function (err) {
            console.log('availableFunction: FAILURE');
            userContext.logout();
            window.location.href = '/';
        }
    });
    

    return (
        <div className="CalcAProof_content">
            <CalcAProofUploadForm setCalcResult={setCalcResult}/>
            <table>
                <tbody>
                    <tr>
                        <td className="CalcAProof_head">
                            <CalcAProofDtResult calcResult={calcResult}/>
                        </td>
                        <td className="CalcAProof_head">
                            <CalcAProofDtMode calcResult={calcResult}/>
                        </td>
                    </tr>
                </tbody>
            </table>
            <CalcAProofDtOutput units={getAProofUnit()}/>
            <CalcAProofDtInput units={getAProofUnit()}/>
        </div>
    );
};
